/** @format */
import React, { useState } from 'react';
import { FilterTextField, FilterSelective , Icons } from 'components';
import { IconButton, Typography, CircularProgress } from '@mui/material';
import { numberWithCommas } from 'utility';
import { getTotalRequestedServiceCalls } from '../../services/ReportRequestedServices';
import { TableItemActionsNew } from 'components';
const status = [
  {
    label: 'همه',
    value: 'all',
  },

  {
    label: 'تایید شده',
    value: 'تایید شده',
  },
  {
    label: 'درخواست داده شده',
    value: 'درخواست داده شده',
  },
  {
    label: 'لغو پس از تایید توسط سرویس دهنده',
    value: 'لغو پس از تایید توسط سرویس دهنده',
  },
  {
    label: 'لغو شده توسط سرویس گیرنده',
    value: 'لغو شده توسط سرویس گیرنده',
  },
  {
    label: 'لغو شده توسط سرویس دهنده',
    value: 'لغو شده توسط سرویس دهنده',
  },
];

const calMethod = {
  FIXED: 'ثابت',
  ONRESPONSE: 'در هر فراخوانی',
};

const columns = (generateApiKey, deleteService) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه سرویس',
    field: 'serviceId',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'نام سرویس',
    field: 'serviceName',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'تاریخ درخواست',
    field: 'dateTime',
    filtering: false,
  },

  {
    title: 'وضعیت',
    field: 'status',
    filterComponent: (props) => <FilterSelective options={status} size="small" {...props} />,
  },
  {
    title: 'client id',
    field: 'clientId',
    filtering: false,
    render: (rowData) => <span style={{ fontFamily: 'Vazir' }}>{rowData?.clientId}</span>,
  },
  {
    title: 'تعداد کل فراخوانی ها',
    field: 'totalCall',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rowData) => <TotalReqs item={rowData} />,
  },

  {
    title: 'عملیات',
    field: 'actions',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => (
      <TableItemActionsNew
        iconButton
        title=""
        otherMenus={[
          {
            title: 'دریافت API KEY',
            isShow: true,
            onClick: () => {
              generateApiKey(rowData.requestId)
            },
            disabled: !(rowData.status === 'تایید شده'),
          },
          {
            title: 'حذف درخواست',
            isShow: true,
            onClick: () => {
              deleteService(rowData)
            },
            disabled: !(rowData.status === 'تایید شده'),
          },
        ]}
      />
    ),
  },
];

const TotalReqs = ({ item }) => {
  // --STATES--//
  const [totalNum, setTotalNum] = useState(null);
  const [loading, setLoading] = useState(false);
  // --HOOKS--//

  // --API REQS--//
  const getTotals = async () => {
    if (!item?.requestId || loading) return;
    setLoading(true);
    try {
      const res = await getTotalRequestedServiceCalls(item.requestId);
      setTotalNum(res?.result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return totalNum == null ? (
    <IconButton onClick={getTotals} size="large">
      {loading ? <CircularProgress size={23} /> : <Icons icon="eye" color="#667585"  size={23} />}
    </IconButton>
  ) : (
    <Typography>{numberWithCommas(totalNum)}</Typography>
  );
};

const columnsId = {
  serviceId: '3014',
  serviceName: '3015',
  serviceProvider: '1285',
  status: '3017',
};

export { columns, columnsId };
